<template>
    <div id="payment-status">
        <div class="plan">
            <div class="highlight">
                <div class="spike"></div>
                <h2 class="period_amount">
                    <template
                        v-if="payment.status === 'pending'"
                    >
                        🕑
                    </template>
                    <template
                        v-else-if="payment.status === 'approved'"
                    >
                        ✔
                        <template v-if="aclidUrl">
                            <img
                                id="1000178711_cpa_testing"
                                :src="aclidUrl"
                                width="1"
                                height="1"
                                border="0"
                            />
                        </template>
                    </template>
                    <template
                        v-else
                    >
                        ✘
                    </template>
                </h2>
            </div>
            <div class="details">
                <template v-if="payment.is_preapproval">
                    <div class="right">
                        <h5 class="duration_type">
                            {{$t(`subscription_result.${payment.status}.title`)}}
                        </h5>
                        <h5 class="access_type">
                            {{$t(`subscription_result.${payment.status}.subtitle`)}}
                        </h5>
                    </div>
                </template>
                <template v-else>
                    <div class="right" :class="payment.status">
                        <h5 class="duration_type">
                            {{$t(`payment_result.${payment.status}.title`)}}
                        </h5>
                        <div
                            v-if="(payment.status === 'canceled' || payment.status === 'failed') && payment.data"
                            class="access_type"
                        >
                            <div
                                style="display: flex;justify-content: space-between;margin: 10px auto"
                            >
                                <div>{{ $t(`payment_result.${payment.status}.status`, {"status": payment.data.TRANS_STATUS_NAME}) }}</div>
                                <div>{{ $t(`payment_result.${payment.status}.trans_id`, {"trans_id": transId }) }}</div>
                            </div>
                            <div
                                style="margin: 5px auto"
                            >{{ payment.data.SERVICE_ADVICE }}</div>
                        </div>
                        <h5
                            v-else
                            class="access_type"
                        >
                            <span v-if="!payment.subscription_plan.data.is_token">
                            {{$t(`payment_result.${payment.status}.subtitle`)}}
                            </span>
                            <span v-else>
                            {{$t(`payment_result.${payment.status}.subtitle_tokens`)}}
                            </span>
                        </h5>
                        <router-link
                            class="support-link"
                            :to="{name: 'support'}">
                            {{ $t('zammad_support.link') }}
                        </router-link>
                    </div>
                </template>
            </div>
        </div>
    
        <div
            v-if="claimsFailedCard"
            class="try-again"
        >
            <h2>{{$t('payment_result.retry_message.title')}}</h2>

            <template v-if="isCCbill">
                <p>{{$t('payment_result.retry_message.ccbill_subtitle', { trans_id: transId })}}</p>
            </template>
            <template v-else>
                <p>{{$t('payment_result.retry_message.ryvyl_subtitle', { trans_id: transId })}}</p>
                <p>{{$t('payment_result.retry_message.ryvyl_text')}}</p>
            </template>

            <!-- <p>{{$t('payment_result.retry_message.try_again')}}</p> -->
        </div>
        
        <div
            v-if="claimsFailedCard"
            class="buttons"
        >
            <router-link
                :to="{ name: 'purchase.subscription', query: { plan: payment.subscription_plan.data.id } }"
                class="btn main-btn"
            >
                {{$t('retry')}}
            </router-link>
        </div>

        <div v-if="!$auth.check()" class="already_existing_account-container">
            <i18n path="login.payment_redirect_msg_with_links.text" tag="p">
                <template v-slot:login_url>
                    <router-link :to="{ name: 'login' }">
                        {{ $t('login.payment_redirect_msg_with_links.login_url') }}
                    </router-link>
                </template>
                <template v-slot:recover_password_url>
                    <router-link :to="{ name: 'login', query: { recover: 1 } }">
                        {{ $t('login.payment_redirect_msg_with_links.recover_password_url') }}
                    </router-link>
                </template>
            </i18n>
        </div>

    </div>
</template>

<script>
  export default {
      props: {
          payment: {
              required: true,
              type: Object,
          }
      },
      data(){
          return {
              advertising: {
                  lastAclid: null,
              },
          }
      },
      mounted(){
          /* Advertising */
          try{
              this.advertising.lastAclid = localStorage.getItem('advertising.lastAclid');

              localStorage.removeItem('advertising.lastAclid')
          }catch(e){/* Do nothing */}
          /* Advertising */
        
          (this.claimsFailedCard) ? this.setFailedCard() : this.clearFailedCards();
          (this.claimsFailedCard) ? this.setPaymentFailed() : this.clearPaymentFailed();
      },
      methods: {
          setPaymentFailed(){
              localStorage.setItem('paymentFailed', this.payment.payment_method.data.id);
          },
          clearPaymentFailed(){
              localStorage.removeItem('paymentFailed')
          },
          setFailedCard(){
              let failedCards =  JSON.parse(localStorage.getItem('failedCards')) || [];
              let newFailedCard = {
                  "id": this.payment.user_credit_card.data.id,
                  "details": this.payment.data
              }
              failedCards.push(newFailedCard);
              localStorage.setItem('failedCards', JSON.stringify(failedCards));
          },
          clearFailedCards(){
              localStorage.removeItem('failedCards')
          },
      },
      computed: {
          aclidUrl(){
              if(!this.payment || !this.advertising.lastAclid){
                  return null;
              }

              const cacheBuster = + new Date() + (Math.random() * 1000).toFixed(0);
              return `http://ads.trafficjunky.net/tj_ads_pt?a=1000178711&member_id=1001477991&cb=${cacheBuster}&cti=${this.payment.operation_number || 'ND'}&ctv=${this.payment.amount}&ctd=${this.payment.is_preapproval ? 'PRE_APROBACION' : 'PAGO'}&aclid=${this.advertising.lastAclid}`
          },
          claimsPaymentFailed(){
              return ( this.payment && (this.payment.status === 'canceled' || this.payment.status === 'failed') );
          },
          claimsFailedCard(){
              return (
                        this.payment &&
                        (this.payment.status === 'canceled' || this.payment.status === 'failed') &&
                        this.payment.data
              );
          },
          isCCbill() {
            const paymentMethod = this.payment.payment_method.data;

            return (
                paymentMethod
                && paymentMethod.key === 'ccbill'
            )
          },
          transId() {
            let transId = this.payment.data.TRANS_ID;
            if (!transId) transId = this.payment.id;
            console.log('transId', transId, this.payment);
            return transId;
          }
      },
  }
</script>

<style scoped lang="scss">
@import '../styles/classes';
@import '../styles/variables';

#payment-status{
    display: flex;
    flex-direction: column;
    align-items: center;

    .plan{
        @extend %plan-block;
        .details{
            background-color: var(--pallete_clear_color);
            color: var(--pallete_dark_text_color);
            min-width: 300px;
        
            @media(max-width: 400px){
                min-width: auto;
            }
        
            .right{
                .support-link{
                    margin-top: 10px;
                    display: block;
                    width: fit-content;
                }

                &.failed{
                    .duration_type{
                        font-size: .9em;
                    }
                    .access_type{
                        font-size: .75em;
                    }
                }
            }
        }
    }

    .try-again{
        margin: 40px 0;
        text-align: center;
        text-transform: uppercase;
        max-width: 600px;
        padding-inline: 1em;
        
        h2{
            font-family: arial, helvetica;
            margin: 0;
            color: red;
        }
        p{
            font-size: 1.2em;
            font-style: italic;
            margin: 0;
        }
    }

    .buttons{
        display: block;
        height: auto;
        // margin-top: 3em;
        text-align: center;
    
        .btn.main-btn{
            @extend %fresh-btn;
            padding: .5em;
        }
    }
}

.already_existing_account-container {
    margin-top: 20px;
    text-align: center;
    color: var(--pallete_dark_text_color);
    a {
        color: var(--pallete_main_color);
    }
}
</style>